import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidationErrors, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ICountry } from '../interfaces/country';
import { CountrieslistService } from '../_services/countrieslist.service';
import { IDobfields } from '../interfaces/dobfields';
import { DobcalculatorService } from '../_services/dobcalculator.service';
import { ICadetformdata } from '../interfaces/cadetformdata';
import { CadetapplicationpreviewService } from '../_services/cadetapplicationpreview.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {NgbCalendar,NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

const states = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID',
  'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE',
  'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];

@Component({
  selector: 'app-cadetapplicationform',
  templateUrl: './cadetapplicationform.component.html',
  styleUrls: ['./cadetapplicationform.component.css']
})

export class CadetapplicationformComponent implements OnInit {
  stateDisplay: any;
  UsCitizenNo: boolean;
  SaNo: boolean;
  BacktoAppForm: boolean;
  cadetBackData;
  yrspaidemply: any;
  yrsintrnshp: any;
  currentlyEmplyd: any;
  jobTerminatedOrNot: any;
  servedInMilitaryOrNot: any;
  servedAsAuxPoliceOrNot: any;
  servedAsVolEMSFireOrNot: any;
  servedAsFDNYExpPrgmOrNot: any;
  
  servedAsFDNYHSOrNot: any;
  
  servedAsFDNYYEAOrNot: any;
  
  comntyVolunteerWorkOrNot: any;
  dischargeTypeOther: any;
  listofCountries: ICountry[];
  dobFieldValues: IDobfields[];
  cadetForm: FormGroup;
  subscription: Subscription;
  cadetNameRegex = "^[a-zA-Z\\s]*$";
  cadetNumberRegex = "[0-9]+";
  cadetEmailRegex = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$";
  maxDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };
 // maxDate: NgbDateStruct  = {year: 2048, month: 12, day: 31};
minDate: NgbDateStruct  = {year: 2000, month: 1, day: 1};
 defaultSuffixValue: any;
  defaultMonthValue: any;
  defaultDateValue: any;
  defaultYearValue: any;
  defaultStateValue: any;
  defaultCountryValue: any;
  defaultYrsPaidEmpSelection: any;
  defaultIntrnYrsSelection: any;
  defaultCurrentEmplySelection: any;
  defaultJobTermSelection: any;
  defaultMilitaryServSelection: any;
  defaultauxPoliceSelection: any;
  defaultvolEmsFireSelection: any;
  defaultfdnyExpPrgmSelection: any;
  defaultfdnyHSSelection: any;
  defaultfdnyYEASelection: any;
  defaultcomntyVolSelection: any;
  modelMilFromDate: any;
  modelMilToDate: any;
  auxPoliceFromDate: any;
  auxPoliceToDate: any;
  volEmsFireFromDate: any;
  volEmsFireToDate: any;
  fdnyExpPrgmFromDate: any;
  fdnyExpPrgmToDate: any;

  fdnyHSFromDate: any;
  fdnyHSToDate: any;

  fdnyYEAFromDate: any;
  fdnyYEAToDate: any;
  invalidDob:any;
  invalidAgeMsg:any="";
  //oldDate: any = new Date("2000-01-01");
  oldDate : any = new Date(new Date().getFullYear() - 20 +'-'+(new Date().getMonth()+1)+'-'+ new Date().getDate());;
  //newDate: any = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };
  //newDate: any = new  Date("2018-01-01");
  newDate: any = new Date(new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+ new Date().getDate());
  constructor( private fb: FormBuilder, private router: Router, private _CountrieslistService: CountrieslistService, private _DobcalculatorService: DobcalculatorService, private _CadetapplicationpreviewService: CadetapplicationpreviewService) {
  
    this.cadetForm = this.fb.group({
      'usCitizenChooseOne': ['', Validators.required],
      'saChooseOne': ['', Validators.required],
      'firstNamePers': ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.pattern(this.cadetNameRegex)])],
      'middleNamePers': ['', Validators.compose([Validators.minLength(1), Validators.maxLength(1), Validators.pattern(this.cadetNameRegex)])],
      'lastNamePers': ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.pattern(this.cadetNameRegex)])],
      'suffixNamePers': [''],
      'dobMonthPers': ['', Validators.compose([Validators.required])],
      'dobDatePers': ['', Validators.compose([Validators.required])],
      'dobYearPers': ['', Validators.compose([Validators.required])],
      'ssnPers': ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(this.cadetNumberRegex)])],
      'strtAddrPers': ['', Validators.compose([Validators.required])],
      'aptNumPers': [''],
      'cityNamePers': ['', Validators.compose([Validators.required, Validators.pattern(this.cadetNameRegex)])],
      'stateNamePers': ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern(this.cadetNameRegex)])],
      'zipCodePers': ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(this.cadetNumberRegex)])],
      'countryNamePers': ['', Validators.compose([Validators.required])],
      'cellNumPers': ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.cadetNumberRegex)])],
      'homeNumPers': ['', Validators.compose([Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.cadetNumberRegex)])],
      'emailAddrPers': ['', Validators.compose([Validators.required, Validators.pattern(this.cadetEmailRegex)])],
      'confirmEmailAddrPers': ['', Validators.compose([Validators.required, Validators.pattern(this.cadetEmailRegex)])],
      'eduChooseOne': ['', Validators.required],
      'schoolNameEdu': ['', Validators.compose([Validators.required])],
      'schoolAddrEdu': [''],
      'cityNameEdu': ['', Validators.compose([Validators.required, Validators.pattern(this.cadetNameRegex)])],
      'stateNameEdu': ['NY'],
      'zipCodeEdu': ['', Validators.compose([Validators.minLength(5), Validators.maxLength(5), Validators.pattern(this.cadetNumberRegex)])],
      'countryNameEdu': ['United States'],
      'yrsPaidEmpSelection': ['', Validators.compose([Validators.required])],
      'YrsEmpSelectOne': [''],
      'intrnShipSelection': ['', Validators.compose([Validators.required])],
      'intrnShipSelectOne': [''],
      'currentEmplySelection': ['', Validators.compose([Validators.required])],
      'currentEmplySelectOne': [''],
      'workTypeEdu': [''],
      'jobTermSelection': ['', Validators.compose([Validators.required])],
      'jobTermReason': [''],
      'militaryServSelection': ['', Validators.compose([Validators.required])],
      'militaryBranchServ': [''],
      'militaryDateServFrom': [''],
      'militaryBranchServTo': [''],
      'dischTypeSelectOne': [''],
      'dischTypeOtherSelected': [''],
      'auxPoliceSelection': ['', Validators.compose([Validators.required])],
      'auxPoliceDateFrom': [''],
      'auxPoliceDateTo': [''],
      'volEmsFireSelection': ['', Validators.compose([Validators.required])],
      'volEmsFireDateFrom': [''],
      'volEmsFireDateTo': [''],
      'fdnyExpPrgmSelection': ['', Validators.compose([Validators.required])],
      'fdnyExpPrgmDateFrom': [''],
      'fdnyExpPrgmDateTo': [''],

      'fdnyHSSelection': ['', Validators.compose([Validators.required])],
      'fdnyHSDateFrom': [''],
      'fdnyHSDateTo': [''],

      'fdnyYEASelection': ['', Validators.compose([Validators.required])],
      'fdnyYEADateFrom': [''],
      'fdnyYEADateTo': [''],

      
      'comntyVolSelection': ['', Validators.compose([Validators.required])],
      'comntyVolWorkDesc': [''],
    }, );
  }

  validDate() {
    if(new Date(this.cadetForm.get('odelMilFromDate').value) < this.oldDate){}
  }

  passwordMatchValidator(frm: FormGroup) {
    return this.cadetForm.get('emailAddrPers').value === this.cadetForm.get('confirmEmailAddrPers').value ? null : {'mismatch': true};
  }

  emailMatch() {
    if( this.cadetForm.get('confirmEmailAddrPers').value !== this.cadetForm.get('emailAddrPers').value) {
      this.cadetForm.get('confirmEmailAddrPers').setValidators([Validators.required]);
    } else {
      this.cadetForm.get('confirmEmailAddrPers').clearValidators();
    }
    //this.cadetForm.get('YrsEmpSelectOne').setValidators([Validators.required]);
    //this.cadetForm.get('currentEmplySelectOne').clearValidators();
    //this.cadetForm.get('intrnShipSelectOne').setValidators([Validators.required]);
  }


  /* Code for auto displaying of State abbrv. */

  statesearch = (texttoDisplay$: Observable<string>) =>
    texttoDisplay$
      .debounceTime(100)
      .distinctUntilChanged()
      .map(term => term.length < 1 ? []
        : states.filter(state => state.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));
  /* ---------------------------------------------------------------------------------- */


  /* Code for checking whether START date is greater than END date */

  checkStartEndDateMilitary(modelMilFromDate, modelMilToDate) {

    if(new Date(modelMilFromDate) < this.oldDate || new Date(modelMilFromDate) > this.newDate) {
      this.cadetForm.get('militaryDateServFrom').setValue(null);
    } 

    if(new Date(modelMilToDate) < this.oldDate || new Date(modelMilToDate) > this.newDate) {
      this.cadetForm.get('militaryBranchServTo').setValue(null);
    }
     
    if (new Date(modelMilFromDate).getTime() > new Date(modelMilToDate).getTime()) {
      alert("Start date is later than End date");
      this.cadetForm.get('militaryBranchServTo').setValue(null);
    }
  }

  checkStartEndDateAuxPolice(auxPoliceFromDate, auxPoliceToDate) {

    if(new Date(auxPoliceFromDate) < this.oldDate || new Date(auxPoliceToDate) > this.newDate) {
      this.cadetForm.get('auxPoliceDateFrom').setValue(null);
    } 

    if(new Date(auxPoliceFromDate) < this.oldDate || new Date(auxPoliceToDate) > this.newDate) {
      this.cadetForm.get('auxPoliceDateTo').setValue(null);
    }

    if (new Date(auxPoliceFromDate).getTime() > new Date(auxPoliceToDate).getTime()) {
      alert("Start date is later than End date");
      this.cadetForm.get('auxPoliceDateTo').setValue(null);
    }
  }
  checkStartEndDatevolEMSFire(volEmsFireFromDate, volEmsFireToDate) {
    if(new Date(volEmsFireFromDate) < this.oldDate || new Date(volEmsFireToDate) > this.newDate) {
      this.cadetForm.get('volEmsFireDateFrom').setValue(null);
    } 

    if(new Date(volEmsFireFromDate) < this.oldDate || new Date(volEmsFireToDate) > this.newDate) {
      this.cadetForm.get('volEmsFireDateTo').setValue(null);
    }

    if (new Date(volEmsFireFromDate).getTime() > new Date(volEmsFireToDate).getTime()) {
      alert("Start date is later than End date");
      this.cadetForm.get('volEmsFireDateTo').setValue(null);
    }
  }

  checkStartEndDateFDNYExpPrgm(fdnyExpPrgmFromDate, fdnyExpPrgmToDate) {

    if(new Date(fdnyExpPrgmFromDate) < this.oldDate || new Date(fdnyExpPrgmToDate) > this.newDate) {
      this.cadetForm.get('fdnyExpPrgmDateFrom').setValue(null);
    } 

    if(new Date(fdnyExpPrgmFromDate) < this.oldDate || new Date(fdnyExpPrgmToDate) > this.newDate) {
      this.cadetForm.get('fdnyExpPrgmDateTo').setValue(null);
    }

    if (new Date(fdnyExpPrgmFromDate).getTime() > new Date(fdnyExpPrgmToDate).getTime()) {
      alert("Start date is later than End date");
      this.cadetForm.get('fdnyExpPrgmDateTo').setValue(null);
    }
  }


  checkStartEndDateFDNYHS(fdnyHSFromDate, fdnyHSToDate) {

    if(new Date(fdnyHSFromDate) < this.oldDate || new Date(fdnyHSToDate) > this.newDate) {
      this.cadetForm.get('fdnyHSDateFrom').setValue(null);
    } 

    if(new Date(fdnyHSFromDate) < this.oldDate || new Date(fdnyHSToDate) > this.newDate) {
      this.cadetForm.get('fdnyHSDateTo').setValue(null);
    }

    if (new Date(fdnyHSFromDate).getTime() > new Date(fdnyHSToDate).getTime()) {
      alert("Start date is later than End date");
      this.cadetForm.get('fdnyHSDateTo').setValue(null);
    }
  }


  checkStartEndDateFDNYYEA(fdnyYEAFromDate, fdnyYEAToDate) {

    if(new Date(fdnyYEAFromDate) < this.oldDate || new Date(fdnyYEAToDate) > this.newDate) {
      this.cadetForm.get('fdnyYEADateFrom').setValue(null);
    } 

    if(new Date(fdnyYEAFromDate) < this.oldDate || new Date(fdnyYEAToDate) > this.newDate) {
      this.cadetForm.get('fdnyYEADateTo').setValue(null);
    }

    if (new Date(fdnyYEAFromDate).getTime() > new Date(fdnyYEAToDate).getTime()) {
      alert("Start date is later than End date");
      this.cadetForm.get('fdnyYEADateTo').setValue(null);
    }
  }



  /* ---------------------------------------------------------------------------------- */

  /* Code for adding and removing validation on sub fields based on the selection. */

  selectYrsEmployment(yrspaidemply) {
    if (yrspaidemply === "Yes") {
      this.cadetForm.get('YrsEmpSelectOne').setValidators([Validators.required]);
      this.cadetForm.get('YrsEmpSelectOne').updateValueAndValidity();
    } else {
      this.cadetForm.get('YrsEmpSelectOne').clearValidators();
      this.cadetForm.get('YrsEmpSelectOne').updateValueAndValidity();
      this.cadetForm.get('YrsEmpSelectOne').setValue("");
    }
  }

  selectIntrnshp(yrsintrnshp) {
    if (yrsintrnshp === "Yes") {
      this.cadetForm.get('intrnShipSelectOne').setValidators([Validators.required]);
      this.cadetForm.get('intrnShipSelectOne').updateValueAndValidity();
    } else {
      this.cadetForm.get('intrnShipSelectOne').clearValidators();
      this.cadetForm.get('intrnShipSelectOne').updateValueAndValidity();
      this.cadetForm.get('intrnShipSelectOne').setValue("");
    }
  }

  selectCurrentEmplyment(currentlyEmplyd) {
    if (currentlyEmplyd === "Yes") {
      this.cadetForm.get('currentEmplySelectOne').setValidators([Validators.required]);
      this.cadetForm.get('currentEmplySelectOne').updateValueAndValidity();
      this.cadetForm.get('workTypeEdu').setValidators([Validators.required]);
      this.cadetForm.get('workTypeEdu').updateValueAndValidity();
    } else {
      this.cadetForm.get('currentEmplySelectOne').clearValidators();
      this.cadetForm.get('currentEmplySelectOne').updateValueAndValidity();
      this.cadetForm.get('currentEmplySelectOne').setValue("");
      this.cadetForm.get('workTypeEdu').clearValidators();
      this.cadetForm.get('workTypeEdu').updateValueAndValidity();
      this.cadetForm.get('workTypeEdu').setValue("");
    }
  }

  selectJobTerminated(jobTerminatedOrNot) {
    if (jobTerminatedOrNot === "Yes") {
      this.cadetForm.get('jobTermReason').setValidators([Validators.required]);
      this.cadetForm.get('jobTermReason').updateValueAndValidity();
    } else {
      this.cadetForm.get('jobTermReason').clearValidators();
      this.cadetForm.get('jobTermReason').updateValueAndValidity();
      this.cadetForm.get('jobTermReason').setValue("");
    }
  }

  servedMilitaryService(servedInMilitaryOrNot) {
    if (servedInMilitaryOrNot === "Yes") {
      this.cadetForm.get('militaryBranchServ').setValidators([Validators.required]);
      this.cadetForm.get('militaryBranchServ').updateValueAndValidity();
      this.cadetForm.get('militaryDateServFrom').setValidators([Validators.required]);
      this.cadetForm.get('militaryDateServFrom').updateValueAndValidity();
      this.cadetForm.get('militaryBranchServTo').setValidators([Validators.required]);
      this.cadetForm.get('militaryBranchServTo').updateValueAndValidity();
      this.cadetForm.get('dischTypeSelectOne').setValidators([Validators.required]);
      this.cadetForm.get('dischTypeSelectOne').updateValueAndValidity();
    } else {
      this.cadetForm.get('militaryBranchServ').clearValidators();
      this.cadetForm.get('militaryBranchServ').updateValueAndValidity();
      this.cadetForm.get('militaryBranchServ').setValue("");
      this.cadetForm.get('militaryDateServFrom').clearValidators();
      this.cadetForm.get('militaryDateServFrom').updateValueAndValidity();
      this.cadetForm.get('militaryDateServFrom').setValue("");
      this.cadetForm.get('militaryBranchServTo').clearValidators();
      this.cadetForm.get('militaryBranchServTo').updateValueAndValidity();
      this.cadetForm.get('militaryBranchServTo').setValue("");
      this.cadetForm.get('dischTypeSelectOne').clearValidators();
      this.cadetForm.get('dischTypeSelectOne').updateValueAndValidity();
      this.cadetForm.get('dischTypeSelectOne').setValue("");
      this.cadetForm.get('dischTypeOtherSelected').clearValidators();
      this.cadetForm.get('dischTypeOtherSelected').updateValueAndValidity();
      this.cadetForm.get('dischTypeOtherSelected').setValue("");
    }
  }

  selectedOtherDiscType(dischargeTypeOther) {
    if (dischargeTypeOther === "Other") {
      this.cadetForm.get('dischTypeOtherSelected').setValidators([Validators.required]);
      this.cadetForm.get('dischTypeOtherSelected').updateValueAndValidity();
    } else {
      this.cadetForm.get('dischTypeOtherSelected').clearValidators();
      this.cadetForm.get('dischTypeOtherSelected').updateValueAndValidity();
      this.cadetForm.get('dischTypeOtherSelected').setValue("");
    }
  }

  workedAsAuxPolice(servedAsAuxPoliceOrNot) {
    if (servedAsAuxPoliceOrNot === "Yes") {
      this.cadetForm.get('auxPoliceDateFrom').setValidators([Validators.required]);
      this.cadetForm.get('auxPoliceDateFrom').updateValueAndValidity();
      this.cadetForm.get('auxPoliceDateTo').setValidators([Validators.required]);
      this.cadetForm.get('auxPoliceDateTo').updateValueAndValidity();
    } else {
      this.cadetForm.get('auxPoliceDateFrom').clearValidators();
      this.cadetForm.get('auxPoliceDateFrom').updateValueAndValidity();
      this.cadetForm.get('auxPoliceDateFrom').setValue("");
      this.cadetForm.get('auxPoliceDateTo').clearValidators();
      this.cadetForm.get('auxPoliceDateTo').updateValueAndValidity();
      this.cadetForm.get('auxPoliceDateTo').setValue("");
    }
  }

  workedAsVolEMSFire(servedAsVolEMSFireOrNot) {
    if (servedAsVolEMSFireOrNot === "Yes") {
      this.cadetForm.get('volEmsFireDateFrom').setValidators([Validators.required]);
      this.cadetForm.get('volEmsFireDateFrom').updateValueAndValidity();
      this.cadetForm.get('volEmsFireDateTo').setValidators([Validators.required]);
      this.cadetForm.get('volEmsFireDateTo').updateValueAndValidity();
    } else {
      this.cadetForm.get('volEmsFireDateFrom').clearValidators();
      this.cadetForm.get('volEmsFireDateFrom').updateValueAndValidity();
      this.cadetForm.get('volEmsFireDateFrom').setValue("");
      this.cadetForm.get('volEmsFireDateTo').clearValidators();
      this.cadetForm.get('volEmsFireDateTo').updateValueAndValidity();
      this.cadetForm.get('volEmsFireDateTo').setValue("");
    }
  }



  workedAsFDNYExpPrgm(servedAsFDNYExpPrgmOrNot) {
    if (servedAsFDNYExpPrgmOrNot === "Yes") {
      this.cadetForm.get('fdnyExpPrgmDateFrom').setValidators([Validators.required]);
      this.cadetForm.get('fdnyExpPrgmDateFrom').updateValueAndValidity();
      this.cadetForm.get('fdnyExpPrgmDateTo').setValidators([Validators.required]);
      this.cadetForm.get('fdnyExpPrgmDateTo').updateValueAndValidity();
    } else {
      this.cadetForm.get('fdnyExpPrgmDateFrom').clearValidators();
      this.cadetForm.get('fdnyExpPrgmDateFrom').updateValueAndValidity();
      this.cadetForm.get('fdnyExpPrgmDateFrom').setValue("");
      this.cadetForm.get('fdnyExpPrgmDateTo').clearValidators();
      this.cadetForm.get('fdnyExpPrgmDateTo').updateValueAndValidity();
      this.cadetForm.get('fdnyExpPrgmDateTo').setValue("");
    }
  }


  workedAsFDNYHS(servedAsFDNYHSOrNot) {
    if (servedAsFDNYHSOrNot === "Yes") {
      this.cadetForm.get('fdnyHSDateFrom').setValidators([Validators.required]);
      this.cadetForm.get('fdnyHSDateFrom').updateValueAndValidity();
      this.cadetForm.get('fdnyHSDateTo').setValidators([Validators.required]);
      this.cadetForm.get('fdnyHSDateTo').updateValueAndValidity();
    } else {
      this.cadetForm.get('fdnyHSDateFrom').clearValidators();
      this.cadetForm.get('fdnyHSDateFrom').updateValueAndValidity();
      this.cadetForm.get('fdnyHSDateFrom').setValue("");
      this.cadetForm.get('fdnyHSDateTo').clearValidators();
      this.cadetForm.get('fdnyHSDateTo').updateValueAndValidity();
      this.cadetForm.get('fdnyHSDateTo').setValue("");
    }
  }

  workedAsFDNYYEA(servedAsFDNYYEAOrNot) {
    if (servedAsFDNYYEAOrNot === "Yes") {
      this.cadetForm.get('fdnyYEADateFrom').setValidators([Validators.required]);
      this.cadetForm.get('fdnyYEADateFrom').updateValueAndValidity();
      this.cadetForm.get('fdnyYEADateTo').setValidators([Validators.required]);
      this.cadetForm.get('fdnyYEADateTo').updateValueAndValidity();
    } else {
      this.cadetForm.get('fdnyYEADateFrom').clearValidators();
      this.cadetForm.get('fdnyYEADateFrom').updateValueAndValidity();
      this.cadetForm.get('fdnyYEADateFrom').setValue("");
      this.cadetForm.get('fdnyYEADateTo').clearValidators();
      this.cadetForm.get('fdnyYEADateTo').updateValueAndValidity();
      this.cadetForm.get('fdnyYEADateTo').setValue("");
    }
  }

  workedAsCommntyVolunteer(comntyVolunteerWorkOrNot) {
    if (comntyVolunteerWorkOrNot === "Yes") {
      this.cadetForm.get('comntyVolWorkDesc').setValidators([Validators.required]);
      this.cadetForm.get('comntyVolWorkDesc').updateValueAndValidity();
    } else {
      this.cadetForm.get('comntyVolWorkDesc').clearValidators();
      this.cadetForm.get('comntyVolWorkDesc').updateValueAndValidity();
      this.cadetForm.get('comntyVolWorkDesc').setValue("");
    }
  }
  /* ---------------------------------------------------------------------------------- */

  /* The function which checks  the final validation during submit. */

  validateAllFields(cadetForm: FormGroup) {
    Object.keys(cadetForm.controls).forEach(field => {
      const control = cadetForm.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }
  /* ---------------------------------------------------------------------------------- */

  /* The function which calls the service to pass on data to Preview Application screen. */


 getAge(dateString: string) {
    const date = moment(dateString, 'YYYY-MMMM-DD')
    const years = moment().diff(date, 'years')
    const days = moment().diff(date.add(years, 'years'), 'days', false)
    return { years, days }
  }


  checkDateValid(value:any){

    if(value.dobYearPers&&value.dobMonthPers&&value.dobDatePers){
      this.invalidDob = !(moment(`${value.dobYearPers}-${value.dobMonthPers}-${value.dobDatePers}`,'YYYY-MMMM-DD').isValid())
      const age = this.getAge(`${value.dobYearPers}-${value.dobMonthPers}-${value.dobDatePers}`);
      if(this.invalidDob){
        this.invalidAgeMsg = "Date of birth is invalid.";
      }else{
        if(age.years>=18&&age.years<=26){
          this.invalidDob = false
        }else{
          this.invalidDob = true
          this.invalidAgeMsg = "You must be at least 18 years old, but not more than 26.";
        }
      }
      
    }

  }
  previewCadetForm({ value }: { value: ICadetformdata[] }) {
  
  
    this.checkDateValid(value)
    if (this.cadetForm.valid && (this.cadetForm.get('confirmEmailAddrPers').value === this.cadetForm.get('emailAddrPers').value)&&(!this.invalidDob)) {
      this._CadetapplicationpreviewService.passCadetFormData(value);
      this.router.navigate(['cadetapplicationpreview']);
    } else {
      alert("One or more required fields have not been filled out or entered incorrectly. Please check highlighted fields.");
      this.validateAllFields(this.cadetForm);
      window.scrollTo(0, 0);
    }
  }
  /* ---------------------------------------------------------------------------------- */

  /* Code to verify whether the appliant is US Citizen or not. */
  UsCitizenOptionYes() {
    this.UsCitizenNo = false;
  }

  UsCitizenOptionNo() {
    this.UsCitizenNo = true;
    alert("Unfortunately, we are unable to proceed with your application. The Fire Cadet Academy requires all applicants to be US citizens. Thank you for your interest in the program.");
  }
  /* ---------------------------------------------------------------------------------- */

  SAOptionYes() {
    this.SaNo = false;
  }

  SAOptionNo() {
    this.SaNo = true;
  }

  ngOnInit() {
    this.invalidDob = false;
    this.listofCountries = this._CountrieslistService.getCountriesList();
    this.dobFieldValues = this._DobcalculatorService.getDOBFields();
    this.UsCitizenNo = false;
    this.SaNo = false;
    this.subscription = this._CadetapplicationpreviewService.getEditFlagValue$.subscribe((res) => this.BacktoAppForm = res);


   this.cadetForm.get('dobYearPers').valueChanges.subscribe(value=>{
    this.invalidDob = false
   })
   this.cadetForm.get('dobMonthPers').valueChanges.subscribe(value=>{
    this.invalidDob = false
   })
   this.cadetForm.get('dobDatePers').valueChanges.subscribe(value=>{
    this.invalidDob = false
   })
    if (this.BacktoAppForm === true) {
      this.subscription = this._CadetapplicationpreviewService.sharedCadetFormData$.subscribe((res) => this.cadetBackData = res);
      this.cadetForm.get('usCitizenChooseOne').setValue(this.cadetBackData.usCitizenChooseOne);
      this.cadetForm.get('saChooseOne').setValue(this.cadetBackData.saChooseOne);
      this.cadetForm.get('firstNamePers').setValue(this.cadetBackData.firstNamePers);
      this.cadetForm.get('middleNamePers').setValue(this.cadetBackData.middleNamePers);
      this.cadetForm.get('lastNamePers').setValue(this.cadetBackData.lastNamePers);
      this.defaultSuffixValue = this.cadetBackData.suffixNamePers;
      this.defaultMonthValue = this.cadetBackData.dobMonthPers;
      this.defaultDateValue = this.cadetBackData.dobDatePers;
      this.defaultYearValue = this.cadetBackData.dobYearPers;
      this.cadetForm.get('ssnPers').setValue(this.cadetBackData.ssnPers);
      this.cadetForm.get('strtAddrPers').setValue(this.cadetBackData.strtAddrPers);
      this.cadetForm.get('aptNumPers').setValue(this.cadetBackData.aptNumPers);
      this.cadetForm.get('cityNamePers').setValue(this.cadetBackData.cityNamePers);
      this.defaultStateValue = this.cadetBackData.stateNamePers;
      this.cadetForm.get('zipCodePers').setValue(this.cadetBackData.zipCodePers);
      this.defaultCountryValue = this.cadetBackData.countryNamePers;
      this.cadetForm.get('cellNumPers').setValue(this.cadetBackData.cellNumPers);
      this.cadetForm.get('homeNumPers').setValue(this.cadetBackData.homeNumPers);
      this.cadetForm.get('emailAddrPers').setValue(this.cadetBackData.emailAddrPers);
      this.cadetForm.get('confirmEmailAddrPers').setValue(this.cadetBackData.confirmEmailAddrPers);
      this.cadetForm.get('eduChooseOne').setValue(this.cadetBackData.eduChooseOne);
      this.cadetForm.get('schoolNameEdu').setValue(this.cadetBackData.schoolNameEdu);
      this.cadetForm.get('schoolAddrEdu').setValue(this.cadetBackData.schoolAddrEdu);
      this.cadetForm.get('cityNameEdu').setValue(this.cadetBackData.cityNameEdu);
      this.cadetForm.get('stateNameEdu').setValue(this.cadetBackData.stateNameEdu);
      this.cadetForm.get('zipCodeEdu').setValue(this.cadetBackData.zipCodeEdu);
      this.cadetForm.get('countryNameEdu').setValue(this.cadetBackData.countryNameEdu);
      this.defaultYrsPaidEmpSelection = this.cadetBackData.yrsPaidEmpSelection;
      this.cadetForm.get('YrsEmpSelectOne').setValue(this.cadetBackData.YrsEmpSelectOne);
      this.defaultIntrnYrsSelection = this.cadetBackData.intrnShipSelection;
      this.cadetForm.get('intrnShipSelectOne').setValue(this.cadetBackData.intrnShipSelectOne);
      this.defaultCurrentEmplySelection = this.cadetBackData.currentEmplySelection;
      this.cadetForm.get('currentEmplySelectOne').setValue(this.cadetBackData.currentEmplySelectOne);
      this.cadetForm.get('workTypeEdu').setValue(this.cadetBackData.workTypeEdu);
      this.defaultJobTermSelection = this.cadetBackData.jobTermSelection;
      this.cadetForm.get('jobTermReason').setValue(this.cadetBackData.jobTermReason);
      this.defaultMilitaryServSelection = this.cadetBackData.militaryServSelection;
      this.cadetForm.get('militaryBranchServ').setValue(this.cadetBackData.militaryBranchServ);
      this.modelMilFromDate = this.cadetBackData.militaryDateServFrom;
      this.modelMilToDate = this.cadetBackData.militaryBranchServTo;
      this.cadetForm.get('dischTypeSelectOne').setValue(this.cadetBackData.dischTypeSelectOne);
      this.cadetForm.get('dischTypeOtherSelected').setValue(this.cadetBackData.dischTypeOtherSelected);
      this.defaultauxPoliceSelection = this.cadetBackData.auxPoliceSelection;
      this.auxPoliceFromDate = this.cadetBackData.auxPoliceDateFrom;
      this.auxPoliceToDate = this.cadetBackData.auxPoliceDateTo;
      this.defaultvolEmsFireSelection = this.cadetBackData.volEmsFireSelection;
      this.volEmsFireFromDate = this.cadetBackData.volEmsFireDateFrom;
      this.volEmsFireToDate = this.cadetBackData.volEmsFireDateTo;
      this.defaultfdnyExpPrgmSelection = this.cadetBackData.fdnyExpPrgmSelection;
      this.defaultfdnyHSSelection = this.cadetBackData.fdnyHSSelection;
      this.defaultfdnyYEASelection = this.cadetBackData.fdnyYEASelection;
      this.fdnyExpPrgmFromDate = this.cadetBackData.fdnyExpPrgmDateFrom;
      this.fdnyExpPrgmToDate = this.cadetBackData.fdnyExpPrgmDateTo;

      this.fdnyHSFromDate = this.cadetBackData.fdnyHSDateFrom;
      this.fdnyHSToDate = this.cadetBackData.fdnyHSDateTo;

      this.fdnyYEAFromDate = this.cadetBackData.fdnyYEADateFrom;
      this.fdnyYEAToDate = this.cadetBackData.fdnyYEADateTo;
      this.defaultcomntyVolSelection = this.cadetBackData.comntyVolSelection;
      this.cadetForm.get('middleNamePers').setValue(this.cadetBackData.middleNamePers); //
      this.cadetForm.get('comntyVolWorkDesc').setValue(this.cadetBackData.comntyVolWorkDesc); //
    }
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}


// WEBPACK FOOTER //
// ./src/app/cadetapplicationform/cadetapplicationform.component.ts